import { Feature } from "../../../redux/user/userSlice";
import axios from "../../privateApi";

export const postUsedFeature = async (feature: Feature) => {
  const res = await axios.post("/users/used-features", { feature: feature });
  return res.data;
};
